import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./master/SideBar";
import Nav from "./master/NavBar";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

import {
  absentPresentData,
  dashboardData,
  SendMessageAbsent,
  SendMessagePresent,
} from "../api/DashboardService";

import { SweetAlertShow, LoadingDiv } from "./master/Master";
import { getBatchList } from "../api/BatchService";
import usePrivateLink from "./config/usePrivateLink";
import { studentFeeTransactionList } from "../api/Student";
import TodayCollectionModal from "./TodayCollectionModal";

export default function Index3() {
  const [loading, setLoading] = useState(false);

  const [sessions, setSessions] = useState([]);
  const [Data, setData] = useState("");
  const [collection, setCollection] = useState("");
  const [paymentDate, setPaymentDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [page, setPage] = useState(1);
  const [type, setType] = useState("");
  const [dta, setDta] = useState("");
  const [batches, setBatches] = useState([]);
  const [batchId, setBatchID] = useState("");

  const navigate = useNavigate();
  const hasAccess = usePrivateLink();

  useEffect(() => {
    setSessions(JSON.parse(localStorage.getItem("sessions") ?? "[]"));
  }, []);

  const handleTodaysEnquiryClick = () => {
    const today = new Date().toISOString().split("T")[0];
    navigate(`/enquiry?start_date=${today}`);
  };

  const handeleTodayAddmissionClick = () => {
    const today = new Date().toISOString().split("T")[0];
    navigate(`/students?start_date=${today}`);
  };

  /* =========================
     DASHBOARD DATA
  ========================= */

  const getData = async () => {
    setLoading(true);

    try {
      const response = await dashboardData();

      if (response.data.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     BATCHES
  ========================= */

  const getBatches = async () => {
    const selectedSession = sessions?.find((s) => s.status == "1")?.id ?? 0;

    const addUrl = `&session_id=${selectedSession}`;

    setLoading(true);

    try {
      const response = await getBatchList(addUrl);
      setBatches(response?.data?.data);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatches();
  }, []);

  /* =========================
     PRESENT MESSAGE
  ========================= */

  const todayPresentMessage = async () => {
    const addUrl = `&batch_id=${batchId}`;

    setLoading(true);

    try {
      const response = await SendMessagePresent(addUrl);

      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     ABSENT MESSAGE
  ========================= */

  const todayAbsentMessage = async () => {
    const addUrl = `&batch_id=${batchId}`;

    setLoading(true);

    try {
      const response = await SendMessageAbsent(addUrl);

      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     TODAY COLLECTION
  ========================= */

  const getTodayCollection = async () => {
    const addUrl = `&start_date=${paymentDate}&end_date=${paymentDate}&page=${page}`;

    try {
      const response = await studentFeeTransactionList(addUrl);

      if (response?.data?.status) {
        setCollection(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };

  /* =========================
     PRESENT / ABSENT DATA
  ========================= */

  const todayPresentAbsent = async (selectedType) => {
    setLoading(true);

    const addUrl = `&type=${selectedType}&page=${page}`;

    try {
      const response = await absentPresentData(addUrl);

      if (response?.data?.status) {
        setDta(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type) {
      todayPresentAbsent(type);
    }
  }, [type, page]);

  useEffect(() => {
    getData();
  }, []);

  /* =========================
     CHARTS
  ========================= */

  const loadOnce = useRef(false);

  useEffect(() => {
    if (!loadOnce.current && Data) {
      window.CollectionExpense = ["Collection", "Expense"];

      window.CollectionExpenseData = [
        Number(Data?.week_data?.collection),
        Number(Data?.week_data?.expenses),
      ];

      window.CollectionExpenseStatus = Data?.week_data?.status
        ? Data.week_data.status.charAt(0).toUpperCase() +
        Data.week_data.status.slice(1).toLowerCase()
        : "Profit";

      window.CollectionExpenseStatusData = Number(
        Data?.week_data?.value || 0,
      ).toFixed(2);

      const script = document.createElement("script");
      script.src = "/assets/js/cards-statistics.js";
      script.async = true;
      document.body.appendChild(script);

      window.SeriesDotNut = [10, 10, 10, 10];
      window.DasChartCategories = Data?.finance_7days?.days;
      window.PresentStudent = Data?.finance_7days?.collection;
      window.AbsentStudent = Data?.finance_7days?.expenses;

      const script3 = document.createElement("script");
      script3.src = "/assets/js/cards-analytics.js";
      script3.async = true;
      document.body.appendChild(script3);

      loadOnce.current = true;
    }
  }, [Data]);

  /* =========================
     UI HELPERS
  ========================= */

  const dashboardStatItems = [
    {
      title: "Active Students",
      value: Data?.total_students,
      icon: "ri-team-line",
      color: "primary",
      link: "/students",
    },
    {
      title: "Total Teachers",
      value: Data?.total_teachers,
      icon: "ri-user-star-line",
      color: "success",
      link: "/staffs",
    },
    {
      title: "Total Batches",
      value: Data?.total_batches,
      icon: "ri-bank-card-2-line",
      color: "warning",
      link: "/batches",
    },
  ];

  const renderStudentTable = () => (
    <div className="table-responsive dashboard-table-wrapper">
      <table className="table align-middle mb-0">
        <thead>
          <tr className="text-center">
            <th>Sr. No.</th>
            <th>Registration No.</th>
            <th>Student</th>
            <th>Father's Name</th>
            <th>Batch</th>
            <th>Phone</th>
            <th>Message Status</th>
          </tr>
        </thead>

        <tbody>
          {dta?.data?.data?.length > 0 ? (
            dta.data.data.map((item, i) => (
              <tr key={item.id}>
                <td className="text-center">
                  <span className="table-index">{i + 1}</span>
                </td>

                <td>
                  <span className="fw-semibold">
                    {item.registration_no || "-"}
                  </span>
                </td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="student-mini-avatar">
                      {(item.name || "S").charAt(0).toUpperCase()}
                    </div>

                    <span className="fw-semibold">{item.name || "-"}</span>
                  </div>
                </td>

                <td>{item.father_name || "-"}</td>

                <td>
                  <span className="badge bg-label-primary rounded-pill">
                    {item.fee_info?.batch?.title || "-"}
                  </span>
                </td>

                <td>{item.phone || "-"}</td>

                <td className="text-center">
                  {type === "present" ? (
                    item?.attendance?.length === 0 ? (
                      <span className="status-badge status-neutral">
                        <i className="ri-time-line"></i>
                        Pending
                      </span>
                    ) : item.attendance?.[0]?.in_message_status === "1" ? (
                      <span className="status-badge status-success">
                        <i className="ri-checkbox-circle-fill"></i>
                        Sent
                      </span>
                    ) : (
                      <span className="status-badge status-danger">
                        <i className="ri-close-circle-fill"></i>
                        Failed
                      </span>
                    )
                  ) : item?.attendance?.length === 0 ? (
                    <span className="status-badge status-neutral">
                      <i className="ri-time-line"></i>
                      In Mark
                    </span>
                  ) : item.attendance?.[0]?.message_status === "1" ? (
                    <span className="status-badge status-success">
                      <i className="ri-checkbox-circle-fill"></i>
                      Sent
                    </span>
                  ) : (
                    <span className="status-badge status-danger">
                      <i className="ri-close-circle-fill"></i>
                      Failed
                    </span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="py-5 text-center">
                <div className="empty-state">
                  <div className="empty-state-icon">
                    <i className="ri-inbox-line"></i>
                  </div>

                  <h6 className="mb-1">No records found</h6>

                  <p className="text-muted mb-0">
                    There are no students available for this view.
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  const renderPagination = () => {
    if (!dta?.data) return null;

    return (
      <div className="dashboard-pagination">
        <div className="pagination-info">
          Showing <strong>{dta?.data?.from || 0}</strong> to{" "}
          <strong>{dta?.data?.to || 0}</strong> of{" "}
          <strong>{dta?.data?.total || 0}</strong> entries
        </div>

        <ul className="pagination pagination-sm mb-0">
          {dta?.data?.links?.map((btn, i) => (
            <li
              key={`${btn?.label}-${i}`}
              className={`page-item ${btn?.active ? "active" : ""
                } ${btn?.url ? "" : "disabled"}`}
            >
              <button
                className="page-link"
                onClick={() => {
                  if (dta?.data?.links?.length === i + 1) {
                    btn?.data?.url && setPage(dta?.data?.current_page + 1);
                  } else if (i === 0) {
                    btn?.data?.url && setPage(dta?.data?.current_page - 1);
                  } else {
                    setPage(btn.label);
                  }
                }}
              >
                {dta?.data?.links?.length === i + 1 ? (
                  <i className="ri-arrow-right-s-line"></i>
                ) : i === 0 ? (
                  <i className="ri-arrow-left-s-line"></i>
                ) : (
                  btn?.label
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                {hasAccess("/") ? (
                  <>
                    {/* ==========================================
                        TOP SECTION
                    ========================================== */}

                    <div className="row g-4 mb-4">
                      {/* Weekly CEP */}
                      <div className="col-xl-4 col-lg-5">
                        <div className="card dashboard-card weekly-card h-100">
                          <div className="card-body p-4">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <span className="dashboard-card-label">
                                  Financial Overview
                                </span>

                                <h5 className="text-primary fw-bold mt-1 mb-1">
                                  Weekly CEP Report
                                </h5>

                                <p className="text-muted small mb-4">
                                  Calculated over the last 7 days
                                </p>
                              </div>

                              <div className="dashboard-icon soft-primary">
                                <i className="ri-line-chart-line"></i>
                              </div>
                            </div>

                            <div className="d-flex align-items-end justify-content-between">
                              <div>
                                <div className="dashboard-value">
                                  ₹{" "}
                                  {Number(
                                    Data?.week_data?.value || 0,
                                  ).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>

                                <div className="mt-2">
                                  {Data?.week_data?.status === "profit" ? (
                                    <span className="trend-badge trend-up">
                                      <i className="ri-arrow-up-line"></i>
                                      {Data?.week_data?.collection > 0 &&
                                        (
                                          (Data?.week_data?.value /
                                            Data?.week_data?.collection) *
                                          100
                                        ).toFixed(2)}
                                      %
                                    </span>
                                  ) : (
                                    <span className="trend-badge trend-down">
                                      <i className="ri-arrow-down-line"></i>
                                      Expense
                                    </span>
                                  )}
                                </div>
                              </div>

                              <div
                                id="totalSalesDonutChart"
                                className="dashboard-donut"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Overview */}
                      <div className="col-xl-8 col-lg-7">
                        <div className="card dashboard-card h-100">
                          <div className="card-header border-0 px-4 pt-4 pb-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <span className="dashboard-card-label">
                                  Dashboard Overview
                                </span>

                                <h5 className="mb-1 text-primary fw-bold">
                                  Overview
                                </h5>

                                <p className="small text-muted mb-0">
                                  Monitor students, staff, enquiries and
                                  batches.
                                </p>
                              </div>

                              <div className="dashboard-icon soft-primary">
                                <i className="ri-dashboard-line"></i>
                              </div>
                            </div>
                          </div>

                          <div className="card-body px-4 pb-4">
                            <div className="row g-3">
                              {dashboardStatItems.map((item) => (
                                <Link
                                  key={item.title}
                                  to={item.link}
                                  className="col-md-3 col-6 text-decoration-none"
                                >
                                  <div className="overview-stat">
                                    <div
                                      className={`overview-icon bg-${item.color}`}
                                    >
                                      <i className={`${item.icon} ri-22px`}></i>
                                    </div>

                                    <div className="min-w-0">
                                      <p className="text-muted small mb-1 text-truncate">
                                        {item.title}
                                      </p>

                                      <h5 className="mb-0 fw-bold">
                                        {item.value ?? 0}
                                      </h5>
                                    </div>
                                  </div>
                                </Link>
                              ))}

                              {/* Today Enquiries */}
                              <div
                                className="col-md-3 col-6"
                                onClick={handleTodaysEnquiryClick}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="overview-stat">
                                  <div className="overview-icon bg-info">
                                    <i className="ri-question-answer-line ri-22px"></i>
                                  </div>

                                  <div className="min-w-0">
                                    <p className="text-muted small mb-1 text-truncate">
                                      Today's Enquiries
                                    </p>

                                    <h5 className="mb-0 fw-bold">
                                      {Data?.today_enquiry ?? 0}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ==========================================
                        CHART + ATTENDANCE
                    ========================================== */}

                    <div className="row g-4 mb-4">
                      {/* Finance Chart */}
                      <div className="col-xl-8">
                        <div className="card dashboard-card h-100">
                          <div className="card-header border-0 px-4 pt-4">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <span className="dashboard-card-label">
                                  Financial Analytics
                                </span>

                                <h5 className="mb-1 text-primary fw-bold">
                                  7 Days Expense - Collection Report
                                </h5>

                                <p className="text-muted small mb-0">
                                  Collection and expense movement over the last
                                  7 days
                                </p>
                              </div>

                              <div className="dashboard-icon soft-info">
                                <i className="ri-bar-chart-grouped-line"></i>
                              </div>
                            </div>
                          </div>

                          <div className="card-body px-4 pb-4">
                            <div
                              id="totalProfitChart"
                              className="dashboard-chart"
                            ></div>
                          </div>
                        </div>
                      </div>

                      {/* Four Stats */}
                      <div className="col-xl-4 col-md-6">
                        <div className="row g-4 h-100">
                          {/* Present */}
                          <div className="col-sm-6">
                            <div
                              className="card attendance-card attendance-present"
                              data-bs-toggle="modal"
                              data-bs-target="#todayPresent"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setType("present");
                              }}
                            >
                              <div className="attendance-top">
                                <div className="attendance-icon">
                                  <i className="ri-user-smile-line"></i>
                                </div>

                                <span className="attendance-count text-success">
                                  {Data?.present_today ?? 0}
                                </span>
                              </div>

                              <div>
                                <h6 className="mb-1 fw-bold">Today Present</h6>

                                <span className="small text-muted">
                                  View present students
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Absent */}
                          <div className="col-sm-6">
                            <div
                              className="card attendance-card attendance-absent"
                              data-bs-toggle="modal"
                              data-bs-target="#todayAbsent"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setType("absent");
                              }}
                            >
                              <div className="attendance-top">
                                <div className="attendance-icon">
                                  <i className="ri-user-unfollow-line"></i>
                                </div>

                                <span className="attendance-count text-danger">
                                  {Data?.absent_today ?? 0}
                                </span>
                              </div>

                              <div>
                                <h6 className="mb-1 fw-bold">Today Absent</h6>

                                <span className="small text-muted">
                                  View absent students
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Admission */}
                          <div className="col-sm-6">
                            <div
                              className="card attendance-card attendance-admission"
                              onClick={handeleTodayAddmissionClick}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="attendance-top">
                                <div className="attendance-icon">
                                  <i className="ri-book-open-line"></i>
                                </div>

                                <span className="attendance-count text-primary">
                                  {Data?.today_students ?? 0}
                                </span>
                              </div>

                              <div>
                                <h6 className="mb-1 fw-bold">
                                  Today Admission
                                </h6>

                                <span className="small text-muted">
                                  View today's admissions
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Collection */}
                          <div className="col-sm-6">
                            <div
                              className="card attendance-card attendance-collection"
                              data-bs-toggle="modal"
                              data-bs-target="#todayCollection"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="attendance-top">
                                <div className="attendance-icon">
                                  <i className="ri-wallet-3-line"></i>
                                </div>

                                <span className="attendance-count text-info">
                                  ₹ {Data?.todayCollection ?? 0}
                                </span>
                              </div>

                              <div>
                                <h6 className="mb-1 fw-bold">
                                  Today Collection
                                </h6>

                                <span className="small text-muted">
                                  View today's collection
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ==========================================
                        BATCH + CALENDAR
                    ========================================== */}

                    <div className="row g-4">
                      {/* Running Batch */}
                      <div className="col-xxl-6">
                        <div className="card dashboard-card h-100">
                          <div className="card-header border-0 px-4 pt-4 pb-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <span className="dashboard-card-label">
                                  Batch Management
                                </span>

                                <h5 className="text-primary fw-bold mb-1">
                                  Running Batches
                                </h5>

                                <p className="small text-muted mb-0">
                                  Current batch schedule and student strength
                                </p>
                              </div>

                              <div className="dashboard-icon soft-warning">
                                <i className="ri-group-line"></i>
                              </div>
                            </div>
                          </div>

                          <div className="card-body px-0 pb-3">
                            <div className="table-responsive">
                              <table className="table align-middle dashboard-main-table mb-0">
                                <thead>
                                  <tr>
                                    <th>Sr. No.</th>
                                    <th>Batch</th>
                                    <th>Time</th>
                                    <th>Students</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {Data?.Batchs?.length === 0 ? (
                                    <tr>
                                      <td
                                        colSpan="5"
                                        className="text-center py-5"
                                      >
                                        <div className="empty-state">
                                          <div className="empty-state-icon">
                                            <i className="ri-calendar-close-line"></i>
                                          </div>

                                          <h6 className="mb-1">
                                            No Batches Available
                                          </h6>

                                          <p className="small text-muted mb-0">
                                            There are no active batches at the
                                            moment.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  ) : (
                                    Data?.Batchs?.map((batch, index) => (
                                      <tr key={batch.id}>
                                        <td>
                                          <span className="table-index">
                                            {index + 1}
                                          </span>
                                        </td>

                                        <td>
                                          <div className="fw-semibold">
                                            {batch.title}
                                          </div>
                                        </td>

                                        <td>
                                          <span className="time-chip">
                                            <i className="ri-time-line"></i>
                                            {batch.start_time} -{" "}
                                            {batch.end_time}
                                          </span>
                                        </td>

                                        <td>
                                          <span className="student-count">
                                            <i className="ri-group-line"></i>
                                            {batch.student_count}
                                          </span>
                                        </td>

                                        <td>
                                          <span
                                            className={`badge ${batch.status === "1"
                                                ? "bg-label-success"
                                                : "bg-label-warning"
                                              } rounded-pill px-3 py-2`}
                                          >
                                            <i
                                              className={`me-1 ${batch.status === "1"
                                                  ? "ri-checkbox-circle-line"
                                                  : "ri-time-line"
                                                }`}
                                            ></i>

                                            {batch.status === "1"
                                              ? "Running"
                                              : "Scheduled"}
                                          </span>
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Calendar */}
                      <div className="col-xxl-6">
                        <div className="card dashboard-card h-100">
                          <div className="card-header border-0 px-4 pt-4 pb-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <div>
                                <span className="dashboard-card-label">
                                  Schedule
                                </span>

                                <h5 className="text-primary fw-bold mb-1">
                                  Academic Calendar
                                </h5>

                                <p className="small text-muted mb-0">
                                  Leaves and important calendar events
                                </p>
                              </div>

                              <div className="dashboard-icon soft-danger">
                                <i className="ri-calendar-event-line"></i>
                              </div>
                            </div>
                          </div>

                          <div className="card-body px-4 pb-4">
                            <div className="calendar-container dashboard-calendar">
                              <FullCalendar
                                plugins={[dayGridPlugin]}
                                initialView="dayGridMonth"
                                events={Data?.leaves}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="welcome-dashboard">
                    <div className="welcome-icon">
                      <i className="ri-dashboard-3-line"></i>
                    </div>

                    <h2 className="text-primary fw-bold">
                      Welcome to SCAI Dashboard
                    </h2>

                    <p className="text-muted mb-0">
                      Manage your school's activities from one place.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =========================================================
          PRESENT MODAL
      ========================================================= */}

      <div
        className="modal fade"
        id="todayPresent"
        tabIndex={-1}
        aria-labelledby="todayPresentLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content dashboard-modal">
            <div className="modal-header dashboard-modal-header">
              <div className="d-flex align-items-center gap-3">
                <div className="modal-title-icon modal-present">
                  <i className="ri-user-smile-line"></i>
                </div>

                <div>
                  <h5
                    className="modal-title fw-bold mb-1"
                    id="todayPresentLabel"
                  >
                    Today Present
                  </h5>

                  <p className="small text-muted mb-0">
                    Students marked present today
                  </p>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body p-0">
              <div className="modal-toolbar">
                <div className="modal-filter">
                  <label className="form-label small fw-semibold mb-1">
                    Select Batch
                  </label>

                  <select
                    name="batch_id[]"
                    className="form-select"
                    multiple
                    value={batchId}
                    onChange={(e) => {
                      const selectedValues = Array.from(
                        e.target.selectedOptions,
                        (option) => option.value,
                      );

                      setBatchID(selectedValues);
                    }}
                  >
                    <option value="all">All Batch</option>

                    {batches?.map((batch) => (
                      <option key={batch?.id} value={batch?.id}>
                        {batch?.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="d-flex align-items-end gap-2">
                  {batchId && (
                    <button
                      className="btn btn-primary"
                      onClick={todayPresentMessage}
                    >
                      <i className="ri-message-2-line me-1"></i>
                      Send Message
                    </button>
                  )}

                  <button
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>

              {renderStudentTable()}
              {renderPagination()}
            </div>
          </div>
        </div>
      </div>

      {/* =========================================================
          ABSENT MODAL
      ========================================================= */}

      <div
        className="modal fade"
        id="todayAbsent"
        tabIndex={-1}
        aria-labelledby="todayAbsentLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content dashboard-modal">
            <div className="modal-header dashboard-modal-header">
              <div className="d-flex align-items-center gap-3">
                <div className="modal-title-icon modal-absent">
                  <i className="ri-user-unfollow-line"></i>
                </div>

                <div>
                  <h5
                    className="modal-title fw-bold mb-1"
                    id="todayAbsentLabel"
                  >
                    Today Absent
                  </h5>

                  <p className="small text-muted mb-0">
                    Students marked absent today
                  </p>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body p-0">
              <div className="modal-toolbar">
                <div className="modal-filter">
                  <label className="form-label small fw-semibold mb-1">
                    Select Batch
                  </label>

                  <select
                    name="batch_id[]"
                    className="form-select"
                    multiple
                    value={batchId}
                    onChange={(e) => {
                      const selectedValues = Array.from(
                        e.target.selectedOptions,
                        (option) => option.value,
                      );

                      setBatchID(selectedValues);
                    }}
                  >
                    <option value="all">All Batch</option>

                    {batches?.map((batch) => (
                      <option key={batch?.id} value={batch?.id}>
                        {batch?.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="d-flex align-items-end gap-2">
                  {batchId && (
                    <button
                      className="btn btn-primary"
                      onClick={todayAbsentMessage}
                    >
                      <i className="ri-message-2-line me-1"></i>
                      Send Message
                    </button>
                  )}

                  <button
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>

              {renderStudentTable()}
              {renderPagination()}
            </div>
          </div>
        </div>
      </div>

      <TodayCollectionModal />

      {/* =========================================================
          PAGE UI STYLES
      ========================================================= */}

      <style>
        {`
          .dashboard-card {
            border: 0 !important;
            border-radius: 18px !important;
            box-shadow: 0 4px 24px rgba(67, 89, 113, 0.08);
            transition: all 0.25s ease;
            overflow: hidden;
          }

          .dashboard-card:hover {
            box-shadow: 0 8px 30px rgba(67, 89, 113, 0.12);
          }

          .dashboard-card-label {
            display: block;
            color: #8a92a6;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.7px;
            text-transform: uppercase;
            margin-bottom: 3px;
          }

          .dashboard-icon {
            width: 44px;
            height: 44px;
            min-width: 44px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
          }

          .soft-primary {
            background: rgba(105, 108, 255, 0.10);
            color: #696cff;
          }

          .soft-info {
            background: rgba(3, 195, 236, 0.10);
            color: #03c3ec;
          }

          .soft-warning {
            background: rgba(255, 171, 0, 0.12);
            color: #ffab00;
          }

          .soft-danger {
            background: rgba(255, 62, 29, 0.10);
            color: #ff3e1d;
          }

          .dashboard-value {
            font-size: 28px;
            line-height: 1.1;
            font-weight: 800;
          }

          .dashboard-donut {
            min-width: 130px;
            min-height: 110px;
          }

          .trend-badge {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 5px 9px;
            border-radius: 8px;
            font-size: 12px;
            font-weight: 700;
          }

          .trend-up {
            color: #28c76f;
            background: rgba(40, 199, 111, 0.10);
          }

          .trend-down {
            color: #ff4c51;
            background: rgba(255, 76, 81, 0.10);
          }

          .overview-stat {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 14px;
            border: 1px solid rgba(67, 89, 113, 0.08);
            border-radius: 14px;
            transition: all 0.2s ease;
            height: 100%;
          }

          .overview-stat:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 18px rgba(67, 89, 113, 0.08);
          }

          .overview-icon {
            width: 42px;
            height: 42px;
            min-width: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            border-radius: 11px;
          }

          .overview-icon.bg-primary {
            background: #696cff !important;
          }

          .overview-icon.bg-success {
            background: #71dd37 !important;
          }

          .overview-icon.bg-warning {
            background: #ffab00 !important;
          }

          .overview-icon.bg-info {
            background: #03c3ec !important;
          }

          .attendance-card {
  height: 100%;
  min-height: 145px;
  padding: 18px;
  border-radius: 17px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.25s ease;
  overflow: hidden;
}

          .attendance-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 9px 25px rgba(67, 89, 113, 0.12);
          }

          .attendance-present {
            border-top: 3px solid #71dd37;
          }

          .attendance-absent {
            border-top: 3px solid #ff4c51;
          }

          .attendance-admission {
            border-top: 3px solid #696cff;
          }

          .attendance-collection {
            border-top: 3px solid #03c3ec;
          }

          .attendance-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
          }

          .attendance-icon {
            width: 42px;
            height: 42px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 21px;
          }

          .attendance-present .attendance-icon {
            color: #71dd37;
            background: rgba(113, 221, 55, 0.12);
          }

          .attendance-absent .attendance-icon {
            color: #ff4c51;
            background: rgba(255, 76, 81, 0.10);
          }

          .attendance-admission .attendance-icon {
            color: #696cff;
            background: rgba(105, 108, 255, 0.10);
          }

          .attendance-collection .attendance-icon {
            color: #03c3ec;
            background: rgba(3, 195, 236, 0.10);
          }

          .attendance-count {
            font-size: 20px;
            font-weight: 800;
            text-align: right;
          }

          .dashboard-chart {
            min-height: 300px;
          }

          .dashboard-main-table thead th,
          .dashboard-table-wrapper thead th {
            font-size: 11px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            color: #8a92a6;
            border-bottom-width: 1px;
          }

          .dashboard-main-table tbody td {
            padding-top: 13px;
            padding-bottom: 13px;
          }

          .table-index {
            width: 28px;
            height: 28px;
            border-radius: 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(105, 108, 255, 0.10);
            color: #696cff;
            font-size: 12px;
            font-weight: 700;
          }

          .time-chip,
          .student-count {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            font-size: 12px;
            color: #697a8d;
            white-space: nowrap;
          }

          .time-chip i {
            color: #696cff;
          }

          .student-count i {
            color: #03c3ec;
          }

          .dashboard-calendar .fc {
            font-size: 12px;
          }

          .dashboard-calendar .fc-toolbar-title {
            font-size: 17px;
            font-weight: 700;
          }

          .dashboard-calendar .fc-button {
            border-radius: 8px !important;
            font-size: 12px;
          }

          .dashboard-calendar .fc-daygrid-day-number {
            font-weight: 600;
          }

          .dashboard-modal {
            border: 0;
            border-radius: 18px;
            overflow: hidden;
          }

          .dashboard-modal-header {
            padding: 18px 22px;
            border-bottom: 1px solid rgba(67, 89, 113, 0.08);
          }

          .modal-title-icon {
            width: 45px;
            height: 45px;
            border-radius: 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 22px;
          }

          .modal-present {
            color: #71dd37;
            background: rgba(113, 221, 55, 0.12);
          }

          .modal-absent {
            color: #ff4c51;
            background: rgba(255, 76, 81, 0.10);
          }

          .modal-toolbar {
            padding: 17px 22px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            gap: 15px;
            border-bottom: 1px solid rgba(67, 89, 113, 0.08);
          }

          .modal-filter {
            min-width: 260px;
            max-width: 340px;
          }

          .modal-filter .form-select {
            min-height: 44px;
            border-radius: 10px;
          }

          .dashboard-table-wrapper {
            padding: 0 22px;
          }

          .dashboard-table-wrapper table {
            min-width: 900px;
          }

          .dashboard-table-wrapper tbody tr {
            transition: background 0.2s ease;
          }

          .dashboard-table-wrapper tbody tr:hover {
            background: rgba(105, 108, 255, 0.025);
          }

          .student-mini-avatar {
            width: 32px;
            height: 32px;
            min-width: 32px;
            border-radius: 9px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(105, 108, 255, 0.10);
            color: #696cff;
            font-size: 12px;
            font-weight: 800;
          }

          .status-badge {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            padding: 5px 9px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: 700;
          }

          .status-success {
            color: #28c76f;
            background: rgba(40, 199, 111, 0.10);
          }

          .status-danger {
            color: #ff4c51;
            background: rgba(255, 76, 81, 0.10);
          }

          .status-neutral {
            color: #8592a3;
            background: rgba(133, 146, 163, 0.10);
          }

          .dashboard-pagination {
            padding: 16px 22px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 15px;
            border-top: 1px solid rgba(67, 89, 113, 0.08);
          }

          .pagination-info {
            color: #697a8d;
            font-size: 12px;
          }

          .dashboard-pagination .page-link {
            border-radius: 7px;
            margin: 0 2px;
          }

          .empty-state {
            padding: 10px;
          }

          .empty-state-icon {
            width: 46px;
            height: 46px;
            margin: 0 auto 10px;
            border-radius: 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(105, 108, 255, 0.08);
            color: #696cff;
            font-size: 22px;
          }

          .welcome-dashboard {
            min-height: 400px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
          }

          .welcome-icon {
            width: 75px;
            height: 75px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(105, 108, 255, 0.10);
            color: #696cff;
            font-size: 34px;
            margin-bottom: 20px;
          }

          @media (max-width: 991.98px) {
            .modal-toolbar {
              flex-direction: column;
              align-items: stretch;
            }

            .modal-filter {
              max-width: 100%;
              width: 100%;
            }

            .modal-toolbar > .d-flex {
              justify-content: flex-end;
            }
          }

          @media (max-width: 767.98px) {
            .dashboard-value {
              font-size: 24px;
            }

            .overview-stat {
              padding: 11px;
            }

            .overview-icon {
              width: 38px;
              min-width: 38px;
              height: 38px;
            }

            .attendance-card {
              min-height: 130px;
              padding: 14px;
            }

            .dashboard-pagination {
              flex-direction: column;
              align-items: flex-start;
            }

            .dashboard-pagination .pagination {
              width: 100%;
              overflow-x: auto;
              flex-wrap: nowrap;
            }
          }
        `}
      </style>
    </>
  );
}
